import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import apis from '../../apis'
import QueryApi from '../../react-query/queryApiClass'
// import { IBetaAITutorPurchaseData } from './types'

// This is assuming you have a GET endpoint like /api/personas
const personasQueryApi = new QueryApi<void, void>({
  api: apis.aiTutor.persona.list, // example
})

export const usePersonas = () => {
  return useQuery<any, AxiosError>({
    queryKey: personasQueryApi.getQueryKey(),
    queryFn: personasQueryApi.getQueryFn(),
  })
}
